import React, { useEffect } from 'react';
import FileDrop from './FileDrop';
import { FileList } from './FileList';
import { isNonEmpty } from '../../utils/arrayUtils';
import { useGetDocuments } from '../../networking/useDocuments';
import { useSessionState } from '../../utils/usePersistedState';
import { CheckBox } from '../base/CheckBox';
import { TextWithDropdown } from '../base/TextWithDropdown';
export const SourcesView = ({ documentTypes, title = 'Sources', textUpload, documents, setDocuments, onViewDocument, onDeleteDocument, allowUpload = true, showCheckbox = true, actionButtons, fileEntryActions, extractElements, }) => {
    const [useKBDocuments, setUseKBDocuments] = useSessionState('useKBDocuments', false);
    const [kbDocuments, setKBDocuments] = useSessionState('kbDocuments', []);
    const { data: documentsResponse, call: callGetDocuments } = useGetDocuments({
        document_ids: [],
        types: documentTypes,
    });
    /**
     * Fetch all the documents of the user when the page is rendered
     */
    useEffect(() => {
        callGetDocuments();
    }, []);
    useEffect(() => {
        if (documentsResponse && documentsResponse.items) {
            // some documents might have been deleted in other tabs
            // if there are documents that are no more present in the DB, they should be deleted from the UI
            const userDocuments = documentsResponse.items.map((doc) => doc.id);
            const nonDeletedDocuments = documents.filter((doc) => userDocuments.includes(doc.id));
            setDocuments(nonDeletedDocuments);
            setKBDocuments(documentsResponse.items.map((doc) => {
                return { ...doc, isExcluded: false };
            }));
        }
    }, [documentsResponse]);
    const onDelete = (deleteResponse) => {
        setDocuments(documents.filter((doc) => !deleteResponse.includes(doc.id)));
        setKBDocuments(kbDocuments.filter((doc) => !deleteResponse.includes(doc.id)));
        if (onDeleteDocument) {
            onDeleteDocument(deleteResponse);
        }
    };
    const addKBDocuments = () => {
        const documentIds = documents.map((doc) => doc.id);
        const kbDocumentsOnly = kbDocuments.filter((doc) => !documentIds.includes(doc.id));
        setDocuments([...documents, ...kbDocumentsOnly]);
        setUseKBDocuments(true);
    };
    const removeKBDocuments = () => {
        const kbDocumentIds = kbDocuments.map((doc) => doc.id);
        const documentsOnly = documents.filter((doc) => !kbDocumentIds.includes(doc.id));
        setDocuments(documentsOnly);
        setUseKBDocuments(false);
    };
    return (React.createElement(React.Fragment, null, isNonEmpty(documents) ? (React.createElement("div", null,
        React.createElement("div", { style: { display: 'flex', flexDirection: 'row', justifyContent: 'space-between' } },
            React.createElement(TextWithDropdown, { title: title }),
            React.createElement("div", { className: "flex-row", style: { gap: 4 } },
                actionButtons,
                React.createElement("div", null, allowUpload && (React.createElement(FileDrop, { useButton: true, text: "", loadingText: "Loading...", multiple: true, setFiles: (docs) => setDocuments([...documents, ...docs]), loadingOnlyText: true, extractElements: extractElements }))))),
        React.createElement("div", { style: { paddingTop: 24 } },
            React.createElement("div", { style: { borderBottom: '1px solid #ccc', paddingBottom: 8 } }, showCheckbox && (React.createElement(CheckBox, { text: 'Use previous supporting documents', checked: useKBDocuments, onChange: () => (useKBDocuments ? removeKBDocuments() : addKBDocuments()) }))),
            React.createElement(FileList, { documents: documents, setDocuments: setDocuments, onViewDocument: onViewDocument, onDeleteFile: onDelete, fileEntryActions: fileEntryActions })))) : (React.createElement("div", { className: "flex-column", style: {
            flexGrow: 1,
            justifyContent: 'center',
            alignItems: 'center',
        } },
        React.createElement(FileDrop, { text: textUpload || 'Upload supporting documents here\n(SOP, industry standard, regulations)', setFiles: (docs) => {
                setDocuments(docs);
            }, multiple: true, accept: 'application/pdf', styleText: { fontSize: 16, fontWeight: 500 }, skipSection: isNonEmpty(kbDocuments)
                ? {
                    text: 'use existing documents',
                    onClick: () => {
                        setDocuments(kbDocuments);
                        setUseKBDocuments(true);
                    },
                }
                : null, extractElements: extractElements })))));
};
